import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaHeadset, FaPlane, FaCalendarAlt, FaUser, FaPaperPlane } from 'react-icons/fa';
import '../style.css';

const PlanYourJourney = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    destination: 'Varanasi',
    requirements: ''
  });

  const destinations = ['Varanasi', 'Ayodhya', 'Mathura', 'Haridwar', 'Rishikesh', 'Prayagraj'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Animation feedback
    const button = e.target.querySelector('button[type="submit"]');
    button.innerHTML = '<FaPaperPlane className="send-icon" /> Sent Successfully!';
    button.style.backgroundColor = '#4CAF50';
    
    setTimeout(() => {
      button.innerHTML = '<FaPaperPlane className="send-icon" /> Send Enquiry';
      button.style.backgroundColor = '';
    }, 2000);
    
    console.log('Form submitted:', formData);
  };

  return (
    <section className="journey-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title animate-fade-in">
            <span className="title-highlight">Plan Your Journey</span>
          </h2>
          <p className="section-subtitle animate-slide-up">Ready to Explore the Divine?</p>
        </div>

        <div className="journey-content">
          {/* Left Content */}
          <div className="info-card animate-slide-left">
            <div className="info-header">
              <h3>Personalized Pilgrimage Planning</h3>
              <p className="info-description">
                Whether it's a spiritual pilgrimage or a heritage tour, our experts are here to craft your perfect itinerary.
              </p>
            </div>

            <div className="contact-info">
              <div className="contact-item animate-pop">
                <div className="contact-icon">
                  <FaPhone />
                </div>
                <div className="contact-details">
                  <span className="contact-label">Call Us</span>
                  <span className="contact-value">+91 6307291567</span>
                </div>
              </div>

              <div className="contact-item animate-pop" style={{ animationDelay: '0.1s' }}>
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <div className="contact-details">
                  <span className="contact-label">Email</span>
                  <span className="contact-value">info@vnstours.com</span>
                </div>
              </div>

              <div className="contact-item animate-pop" style={{ animationDelay: '0.2s' }}>
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-details">
                  <span className="contact-label">Visit</span>
                  <span className="contact-value">Varanasi, Uttar Pradesh</span>
                </div>
              </div>

              <div className="contact-item animate-pop" style={{ animationDelay: '0.3s' }}>
                <div className="contact-icon">
                  <FaHeadset />
                </div>
                <div className="contact-details">
                  <span className="contact-label">Support</span>
                  <span className="contact-value">24/7 Assistance</span>
                </div>
              </div>
            </div>

          </div>

          {/* Right Form */}
          <div className="enquiry-form animate-slide-right">
            <div className="form-header">
              <h3>Start Your Spiritual Journey</h3>
              <p>Fill in your details and we'll get back to you within 24 hours</p>
            </div>

            <form onSubmit={handleSubmit} className="enquiry-form-container">
              <div className="form-group">
                <div className="input-icon">
                  <FaUser />
                </div>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
                <div className="input-underline"></div>
              </div>

              <div className="form-group">
                <div className="input-icon">
                  <FaPhone />
                </div>
                <input
                  type="tel"
                  name="phoneNumber"
                  placeholder="Phone Number"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                  className="form-input"
                />
                <div className="input-underline"></div>
              </div>

              <div className="form-group">
                <div className="input-icon">
                  <FaMapMarkerAlt />
                </div>
                <select
                  name="destination"
                  value={formData.destination}
                  onChange={handleChange}
                  className="form-select"
                >
                  {destinations.map((dest, index) => (
                    <option key={index} value={dest}>{dest}</option>
                  ))}
                </select>
                <div className="select-arrow">▼</div>
              </div>

              <div className="form-group">
                <textarea
                  name="requirements"
                  placeholder="Your Travel Requirements - Tell us about your dates and preferences..."
                  value={formData.requirements}
                  onChange={handleChange}
                  required
                  className="form-textarea"
                  rows="4"
                />
                <div className="textarea-underline"></div>
              </div>

              <button type="submit" className="submit-btn">
                <FaPaperPlane className="send-icon" /> Send Enquiry
              </button>
            </form>

            <div className="form-footer">
              <p>✅ All information is kept confidential</p>
              <p>✅ No spam, guaranteed</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlanYourJourney;